const { defaultLanguage } = require('../locales');

const getCollectionMappingKey = (slug, language) =>
  language === defaultLanguage?.id ? slug : `${language}/${slug}`;

module.exports = { getCollectionMappingKey };
